@if (
  selectedMember &&
  authService.isAuthorized([PermissionsEnum.Settings_team_member_view])
) {
  <app-member-information
    (close)="selectedMember = undefined"
    [memberId]="selectedMember.hesId!"
  >
  </app-member-information>
}
<div class="subpage-container">
  <div class="container g-0 m-0">
    <div
      class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2"
    >
      <app-search
        placeholder="{{ 'SETTINGS_SEARCHBYNAME' | translate }}"
        (searchChange)="searchChange($event)"
      >
      </app-search>
    </div>
    <div class="row g-0 m-0 pt-2 gap-2 pb-3 ps-5 pe-5">
      <div
        *ngFor="let row of userData; let i = index"
        class="row g-0 p-0 d-flex justify-content-between member-info p-3"
      >
        <div
          class="col d-flex p-0 justify-content-start"
          (click)="handleRowClickUser(row)"
        >
          <div
            class="col-md-1 g-0 p-0 d-flex justify-content-center align-items-center member-picture"
            [ngStyle]="{
              'background-color': colorMap[row.firstName!.charAt(0)!],
            }"
          >
            <span class="item-title">{{ row.firstName!.charAt(0) }}</span>
          </div>
          <div class="col ps-3 pe-3">
            <div>
              <span class="item-title"
                >{{ row.firstName }} {{ row.lastName }}</span
              >
            </div>
            <div class="text bolded">
              <span>{{ row.email }}</span>
              <svg-icon
              alt="Dot"
                src="assets/settings/dot.svg"
                class="ps-2 pe-2"
              ></svg-icon>
              <span>{{ row.phoneNumber ? row.phoneNumber : "/" }}</span>
              <svg-icon
              alt="Dot"
                src="assets/settings/dot.svg"
                class="ps-2 pe-2"
              ></svg-icon>
              <span
                >{{ "ADDED" | translate }}
                {{ row.createdTime | date: "d MMMM, y" }}</span
              >
              <svg-icon
              alt="Dot"
                src="assets/settings/dot.svg"
                class="ps-2 pe-2"
              ></svg-icon>
              <span
                >{{ "CREATEDBY" | translate }}
                {{ row.createdByUserEmail }}</span
              >
            </div>
          </div>
        </div>
        <div
          class="col-auto p-0 subtitle d-flex justify-content-end align-items-center text"
        >
          <span class="pe-2">{{ row.role }}</span>
          <span
            class="status"
            [ngClass]="{
              active: row.status === 'Active',
              pending: row.status === 'Pending',
              inactive: row.status === 'Inactive',
            }"
            >{{ row.status }}</span
          >
          <svg-icon
          alt="More"
            class="more-icon ps-1"
            src="assets/settings/more-icon.svg"
            (click)="setActiveRow(i)"
          ></svg-icon>
          <!-- Dropdown -->
          @if (
            authService.isAuthorized([
              PermissionsEnum.Settings_team_member_modify,
            ])
          ) {
            <div *ngIf="activeRow === i" class="positioning">
              <div class="overlay-light" (click)="setActiveRow(null)"></div>
              <div class="dropdown-button p-2">
                <div class="dropdown-button-menu p-0 m-0">
                  <div
                    class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                    (click)="editMember(row.hesId!)"
                  >
                    <svg-icon alt="Edit" src="assets/device/edit.svg"></svg-icon>
                    <span class="ps-2 item-title">{{
                      "EDITMEMBER" | translate
                    }}</span>
                  </div>
                  @if (
                    !(row.status === "Inactive") &&
                    authService.isAuthorized([
                      PermissionsEnum.Settings_team_member_modify,
                    ])
                  ) {
                    <div
                      class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                      (click)="changeStatus(row.hesId!, UserStatus.Inactive)"
                    >
                      <svg-icon alt="Deactivate" src="assets/settings/deactivate.svg"></svg-icon>
                      <span class="ps-2 item-title">{{
                        "DEACTIVATE" | translate
                      }}</span>
                    </div>
                  }
                  @if (
                    row.status === "Inactive" &&
                    authService.isAuthorized([
                      PermissionsEnum.Settings_team_member_modify,
                    ])
                  ) {
                    <div
                      class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                      (click)="changeStatus(row.hesId!, UserStatus.Active)"
                    >
                      <svg-icon
                        alt="Activate"
                        src="assets/settings/activate.svg"
                      ></svg-icon>
                      <span class="ps-2 item-title">{{
                        "ACTIVATE" | translate
                      }}</span>
                    </div>
                  }
                  @if (
                    authService.isAuthorized([
                      PermissionsEnum.Settings_team_member_delete,
                    ])
                  ) {
                    <div
                      class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                      (click)="isModalOpen = true; selectedRowId = row.hesId!"
                    >
                      <svg-icon
                      alt="Trash Can"
                        src="assets/settings/trash-can-red.svg"
                      ></svg-icon>
                      <span class="ps-2 item-title red">{{
                        "DELETE" | translate
                      }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          <!---->
        </div>
      </div>
    </div>
  </div>
  <div class="container-down">
    <app-pagination
      [lastPageSize]="lastPageSize"
      [numberOfDevices]="numberOfMembers"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      (pageChange)="pageChange($event)"
    >
    </app-pagination>
  </div>
</div>

<app-confirm-dialog *ngIf="isModalOpen" titleKey="DELETE" question="USER_DELETE"
  (confirm)="delete(selectedRowId!)" (cancel)="isModalOpen = false; activeRow = null"></app-confirm-dialog>
